/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IEspecialty } from 'app/shared/model/especialty.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { HikeType } from 'app/shared/model/enumerations/hike-type.model';

export interface IDoctorCharges {
  id?: string;
  consultationCharge?: number;
  followupCharge?: number;
  followupDays?: number;
  followupVisits?: number;
  active?: boolean;
  microSec?: number;
  lastupdated?: number;
  timestampentry?: number;
  cursor?: number;
  chargeType?: string;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string;
  emergencyHike?: number | null;
  hishRiskHike?: number | null;
  emergencyHikeType?: keyof typeof HikeType | null;
  hishRiskHikeType?: keyof typeof HikeType | null;
  multiplierApplied?: boolean;
  startDate?: number;
  endDate?: number | null;
  suspended?: boolean;
  draft?: boolean;
  doctor?: IDoctor;
  hospital?: IHospital | null;
  scheme?: IPaymentScheme | null;
  specialty?: IEspecialty | null;
}

export const defaultValue: Readonly<IDoctorCharges> = {
  active: false,
  multiplierApplied: false,
  suspended: false,
  draft: false,
};
